import { InternalAxiosRequestConfig } from 'axios';

import { getAccessTokenFromActiveProvider } from '@/features/auth/contexts/auth-provider';

export const attachAccessToken = async (config: InternalAxiosRequestConfig) => {
  const token = await getAccessTokenFromActiveProvider();

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};
